import globalStyles from './globalStyles';
import normalizeCSS from './normalizeCSS';
var staticStyles = [normalizeCSS, globalStyles];
export default staticStyles;